import axios from "axios";

export async function uploadMessage(createPhishUrl, requestBody, requestConfig, selectedImageFile) {
    try {
        const response = await axios.post(createPhishUrl, requestBody, requestConfig);

        if (selectedImageFile) {
            await axios.put(response.data.message, selectedImageFile, {
                method: "PUT",
                headers: {
                    "Content-Type": selectedImageFile.type,
                },
            });

            return { success: true, message: "Thank you, the message successfully posted" };
        }

        return { success: true, message: "Thank you, the message successfully posted" };
    } catch (error) {
        let errorMessage = "The backend server is currently down, please try again later";

        if (error.response?.status === 401 || error.response?.status === 403) {
            errorMessage = error.response.data.message;
        }

        return { success: false, message: errorMessage };
    }
}
